/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeGroup
 */
export interface EmployeeGroup {
    /**
     * 
     * @type {number}
     * @memberof EmployeeGroup
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeGroup
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeGroup
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeGroup
     */
    position: number;
}

/**
 * Check if a given object implements the EmployeeGroup interface.
 */
export function instanceOfEmployeeGroup(value: object): value is EmployeeGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function EmployeeGroupFromJSON(json: any): EmployeeGroup {
    return EmployeeGroupFromJSONTyped(json, false);
}

export function EmployeeGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'position': json['position'],
    };
}

  export function EmployeeGroupToJSON(json: any): EmployeeGroup {
      return EmployeeGroupToJSONTyped(json, false);
  }

  export function EmployeeGroupToJSONTyped(value?: EmployeeGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'position': value['position'],
    };
}

